<div [className]="className" [style]="styleName">

      <div class="underline_hover accord-head accord-open" 
           (click)="onClick($event)"  
           (keypress)="keyPress($event)" tabindex="0" aria-expanded="false" role="link">
            <span style="display:inline-block; width:1.3em; vertical-align: top;">{{open?'-':'+'}}</span>
            <span [className]="labelClass"  [style]="labelStyle" 
                   style="display:inline-block"
                  [innerHTML]="label|translate:labelParam" ></span>

      </div>
      
      <div style="background-color: rgb(196, 224, 235);  margin-left:0.05em; margin-top:0.2em; margin-right:0.4em;">
            <div [className]="inputClass"  [style]="inputStyle" 
                  [hidden]="!open">
                  <div class="accordion-inner" tabindex="-1" style="padding-left:1.0em">
                  <span [className]="textClass"  [style]="textStyle" translate><ng-content></ng-content></span>
                  </div>
            </div>
      </div>
<div>
<!-- <span [className]="labelClass"  [style]="labelStyle"   [ngClass]="{'underline':!opened }" -->